<template>
  <div>
    <el-row>

      <el-col :span="24">

        <h3>{{ $t('title.next-schedule') }}</h3>

        <data-form :fields="fields" :entity="formModel" @submit="setupTime" :hideButtons="true" />

        <h3>{{ $t('title.pending-jobs') }}</h3>

        <data-table model="scheduled-jobs" :columns="['id']" :plus-cells="['payloadCell']" :operations="operations"/>

      </el-col>
    </el-row>

    <el-dialog
      :title="$t('title.remove')"
      :visible="!!modelToDelete"
      width="30%"
      :before-close="() => { modelToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="deleteModel">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { get, post } from 'providers/http'
import payloadCell from './PayloadCell'
import DataTable from 'components/DataTable'

DataTable.components = DataTable.components || {}
DataTable.components['payloadCell'] = payloadCell

export default {
  name: 'scheduled-job-panel',
  data () {
    return {
      modelToDelete: null,
      operations: [{
        label: 'remove',
        icon: 'delete',
        permission: ['DELETE_SCHEDULED_JOB', 'server_id'],
        method: (model) => (this.modelToDelete = model)
      }],
      formModel: {
        scheduleTime: null
      },
      fields: {
        scheduleTime: { type: 'datetime' }
      }
    }
  },
  methods: {
    async setupTime ({ scheduleTime }) {
      try {
        await post('api/v1/scheduled-jobs/setup-time', { scheduleTime: scheduleTime.getTime() })

        this.showSuccess('scheduleTime-setup')
      }
      catch (err) {
        console.err(err)
      }
    },
    deleteModel () {
      this.$store.dispatch(`scheduled-jobs/delete`, this.modelToDelete)
      this.modelToDelete = null
    }
  },
  async created () {
    const { scheduleTime } = await get('api/v1/scheduled-jobs/scheduleTime')

    if (scheduleTime) {
      this.formModel.scheduleTime = new Date(parseInt(scheduleTime))
    }
  },
  components: {
    DataTable
  }
}
</script>



// WEBPACK FOOTER //
// ScheduledJobPanel.vue?24df7fc7